module.exports = __webpack_public_path__ + "static/media/footer-icon-github.efb390d2.svg";